import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../features/auth/authSlice";

import FooterStatic from "../components/FooterStatic";

import {
  Plane, Hotel, Briefcase,
  Headphones, ShieldCheck, MapPin,
  Phone, Mail, CheckCircle2, Globe, Users,
  CreditCard, Monitor, Award, MoonStar, BedDouble, TrendingUpDown
} from 'lucide-react';

export default function Franchise() {
  const navigate = useNavigate();
  const user = useSelector(selectCurrentUser);
  useEffect(() => {
    if (user) {
      navigate("/flight");
    }
  }, []);

  const options = [
    {
      id: 1,
      label: "Marketing Support",
      value: [
        {
          id: 1,
          value: "Social Media Campaign up to ₹50,000"
        },
        {
          id: 2,
          value: "Social Media Campaign up to ₹50,000"
        },
        {
          id: 3,
          value: "Social Media Campaign up to ₹25,000"
        },
        {
          id: 4,
          value: "Social Media Campaign up to ₹15,000"
        }
      ],
    },
    {
      id: 2,
      label: "Minimum Guaranteed",
      value: [
        {
          id: 1,
          value: "₹60,000*"
        },
        {
          id: 2,
          value: "₹60,000*"
        },
        {
          id: 3,
          value: "Not Available"
        },
        {
          id: 4,
          value: "Not Available"
        }
      ]
    },
    {
      id: 3,
      label: "Area Requirement",
      value: [
        {
          id: 1,
          value: "250 – 400 sq. ft."
        },
        {
          id: 2,
          value: "250 – 400 sq. ft."
        },
        {
          id: 3,
          value: "250 – 400 sq. ft."
        },
        {
          id: 4,
          value: "150 – 350 sq. ft."
        }
      ]
    },
    {
      id: 4,
      label: "Relationship Manager",
      value: [
        {
          id: 1,
          value: "Yes"
        },
        {
          id: 2,
          value: "Yes"
        },
        {
          id: 3,
          value: "Yes"
        },
        {
          id: 4,
          value: "Yes"
        }
      ]
    },
    {
      id: 5,
      label: "Database Leads",
      value: [
        {
          id: 1,
          value: "Yes (Minimum 100 Leads)"
        },
        {
          id: 2,
          value: "Yes (Minimum 100 Leads)"
        },
        {
          id: 3,
          value: "Yes (Minimum 100 Leads)"
        },
        {
          id: 4,
          value: "As per Availability"
        }
      ]
    },
  ];
  const tierOptions = [
    {
      id: 1,
      label: "Tier-1",
      value: "",
    },
    {
      id: 2,
      label: "Tier-2",
      value: "",
    },
    {
      id: 3,
      label: "Tier-3",
      value: "",
    },
    {
      id: 4,
      label: "Tier-4 & 5",
      value: "",
    },
  ];


  return (
    <>
      <div className="min-h-screen bg-white">

        <div className="font-sans text-gray-700 bg-white">

          {/* --- HEADER --- */}


          {/* --- HERO SECTION --- */}
          <section className="relative bg-blue-50 py-16 md:py-20">
            <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 leading-tight">
                  Goertrip Franchise
                </h1>
                <p className="text-4xl md:text-4xl text-gray-600 mb-8">
                  Start your Business with India's<br />
                  <span className="font-semibold text-blue-600">One-stop Leading Travel OTA.</span>
                </p>

                <a
                  className="bg-blue-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-600 transition shadow-lg"
                  href={"/register"}
                >
                  Register Now
                </a>
                &nbsp;

              </div>
              <div className="relative h-64 md:h-96 rounded-2xl overflow-hidden shadow-xl bg-gray-200">
                {/* Image Placeholder */}
                <img
                  src="goertrip/1760618916dum.webp?auto=format&fit=crop&q=80&w=1000"
                  alt="Office Interior"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>

          {/* --- BLUE STATS BAR --- */}
          <section className="bg-blue-600 py-8">
            <div className="max-w-7xl mx-auto px-4 grid grid-cols-2 md:grid-cols-5 gap-6 text-white">
              {[
                { icon: <Award />, text: "Best Commission Structure" },
                { icon: <Users />, text: "Dedicated Account Manager" },
                { icon: <Headphones />, text: "24x7 Support Team" },
                { icon: <Monitor />, text: "User Friendly Interface" },
                { icon: <ShieldCheck />, text: "Trusted Brand Name" }
              ].map((item, idx) => (
                <div key={idx} className="flex flex-col items-center text-center gap-2">
                  <div className="p-2 bg-blue-500 rounded-full">{item.icon}</div>
                  <span className="text-xs md:text-sm font-medium">{item.text}</span>
                </div>
              ))}
            </div>
          </section>

          {/* --- KEY HIGHLIGHTS LIST --- */}
          <section className="py-12 bg-white">
            <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-y-4 gap-x-12">
              {[
                "Lowest Investment & High ROI",
                "Flight Tickets, Hotels, Bus & Holiday Packages",
                "Automatic Refund Processing",
                "Real-time Booking & Cancellation",
              ].map((text, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <div className="bg-blue-100 p-1 rounded-full">
                    <CheckCircle2 size={16} className="text-blue-600" />
                  </div>
                  <span className="text-gray-700 font-medium">{text}</span>
                </div>
              ))}
            </div>
          </section>

          {/* --- CTA DARK STRIP --- */}
          <section className="bg-gray-900 text-white py-12 relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 text-center relative z-10">
              <h2 className="text-2xl md:text-3xl font-bold mb-2">Want to start your own business?</h2>
              <p className="text-gray-400">Join the Goertrip franchise family today.</p>
            </div>
            <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
          </section>

          {/* --- PRODUCTS & SERVICES --- */}
          <section className="py-16 text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-12">Our Products and Services</h2>
            <div className="max-w-6xl mx-auto px-4 flex flex-wrap justify-center gap-8 md:gap-16">
              {[
                { icon: <Plane />, label: "Flights" },
                { icon: <Hotel />, label: "Hotels" },
                { icon: <Briefcase />, label: "Holidays" },
                { icon: <Globe />, label: "Visa/Passport" },
                { icon: <MoonStar />, label: "Umrah/Hajj" },
                { icon: <ShieldCheck />, label: "Insurance" },
                { icon: <TrendingUpDown />, label: "Forex" },
                { icon: <BedDouble />, label: "Homestay" },
              ].map((item, idx) => (
                <div key={idx} className="flex flex-col items-center gap-3 w-24">
                  <div className="w-16 h-16 bg-blue-50 text-blue-500 rounded-full flex items-center justify-center hover:bg-blue-500 hover:text-white transition-colors duration-300 shadow-sm">
                    {item.icon}
                  </div>
                  <span className="font-bold text-sm text-gray-700">{item.label}</span>
                </div>
              ))}
            </div>
          </section>

          {/* --- BENEFITS SECTION (Split) --- */}
          <section className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center">
              <div className="rounded-2xl overflow-hidden shadow-lg h-80 md:h-[500px]">
                <img
                  src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&q=80&w=1000"
                  alt="Office"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Goertrip Franchise Benefits</h2>
                <p className="text-gray-600 mb-6">
                  We provide continuous support to our franchise partners to ensure they grow with us. Here are some key benefits:
                </p>
                <ul className="space-y-4">
                  {[
                    "Zero maintenance cost & high returns",
                    "Wide range of travel products under one roof",
                    "Special fares and deals for franchise",
                    "Marketing & Branding support provided",
                    "24x7 Helpdesk support for all queries"
                  ].map((point, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <div className="mt-1 bg-blue-500 p-1 rounded-full">
                        <CheckCircle2 size={12} className="text-white" />
                      </div>
                      <span className="text-gray-700">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>

          {/* --- URGENT QUERY / CONTACT BAR --- */}
          <section className="bg-blue-500 text-white py-8">
            <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">
              <div>
                <h3 className="text-xl font-bold">Have an urgent query?</h3>
                <p className="text-blue-100">Feel free to reach out for support.</p>
              </div>
              <div className="flex flex-wrap gap-6 items-center">
                <div className="flex items-center gap-2">
                  <Phone size={18} />
                  <span>+91 940-389-1941</span>
                </div>
                <div className="flex items-center gap-2">
                  <Mail size={18} />
                  <span>hello@goertrip.com</span>
                </div>
                <button className="bg-white text-blue-600 px-6 py-2 rounded-lg font-bold text-sm">
                  Contact Us
                </button>
              </div>
            </div>
          </section>

          {/* --- HOW WE SUPPORT --- */}
          <section className="py-16">
            <div className="max-w-7xl mx-auto px-4 text-center">
              <h2 className="text-3xl font-bold text-gray-900 mb-2">How Goertrip Will Support</h2>
              <p className="text-gray-500 mb-12">Goertrip Franchise</p>

              <div className="grid md:grid-cols-3 gap-8">
                {[
                  { title: "Technical Training", desc: "Complete platform training provided by experts.", img: "https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&q=80" },
                  { title: "Marketing Support", desc: "Posters, banners & digital assets provided.", img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80" },
                  { title: "Operational Support", desc: "Dedicated team for bookings & refunds.", img: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&q=80" }
                ].map((item, idx) => (
                  <div key={idx} className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 group hover:shadow-xl transition">
                    <div className="h-48 overflow-hidden">
                      <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                    </div>
                    <div className="p-6">
                      <h3 className="font-bold text-lg mb-2">{item.title}</h3>
                      <p className="text-gray-600 text-sm">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* --- WHY CHOOSE US (Blue Background Section) --- */}
          <section className="bg-blue-500 py-16 relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center relative z-10">

              <div className="rounded-xl overflow-hidden shadow-2xl border-4 border-white/20">
                <img
                  src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80"
                  alt="Happy Customer"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="text-white">
                <h2 className="text-3xl font-bold mb-8">Why do customers choose Goertrip Franchise?</h2>
                <ul className="space-y-4">
                  {[
                    "Zero Convenience Fee on Flight Bookings",
                    "Lowest airfares across all airlines",
                    "Secure and safe payment gateway",
                    "Easy cancellation and refund policy",
                    "Transparency in pricing (No Hidden costs)",
                    "Trust of millions of happy customers",
                    "Flexi payment",
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <CheckCircle2 className="shrink-0 text-blue-200" />
                      <span className="font-medium">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>

          {/* --- CRITERIA SECTION --- */}
          <section className="py-16 bg-blue-50">
            <div className="max-w-4xl mx-auto px-4 text-center">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
                Criteria required to open an <br /> <span className="text-blue-600">Goertrip Franchise?</span>
              </h2>
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col md:flex-row justify-center gap-8 md:gap-16 text-left md:text-center">
                <div>
                  <h4 className="font-bold text-gray-700 mb-2 flex items-center md:justify-center gap-2">
                    <MapPin size={18} className="text-blue-500" /> Valid Premises
                  </h4>
                  <p className="text-sm text-gray-500">Office space or shop required.</p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-700 mb-2 flex items-center md:justify-center gap-2">
                    <Monitor size={18} className="text-blue-500" /> IT Infrastructure
                  </h4>
                  <p className="text-sm text-gray-500">Computer, Printer & Internet.</p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-700 mb-2 flex items-center md:justify-center gap-2">
                    <CreditCard size={18} className="text-blue-500" /> Valid Documents
                  </h4>
                  <p className="text-sm text-gray-500">PAN Card, Aadhaar, GST (if any).</p>
                </div>
              </div>
            </div>
          </section>

          {/* --- PRICING PLANS --- */}
          <section className="py-16">
            <div className="max-w-7xl mx-auto px-4">
              <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">GOERTRIP Franchise Plans</h2>

              <div className="overflow-x-auto">
                <div className="min-w-[800px] grid grid-cols-5 gap-4 text-center">
                  {/* Header Column */}
                  <div className="col-span-1 pt-12 bg-blue-50  rounded-t-xl flex flex-col justify-end pb-4 font-bold text-gray-600 text-left px-4">
                    Brand Fee
                  </div>
                  {/* Plan Headers */}
                  {tierOptions.map((value, plan) => (
                    <div key={plan} className="col-span-1 bg-blue-50 rounded-t-xl p-6">
                      <h3 className="text-xl font-bold text-blue-600">{value.label}</h3>
                      {/* <p className="text-sm text-gray-500 mt-2">Starting at</p> */}
                      <div className="text-2xl font-bold text-gray-800">{value.value}</div>
                    </div>
                  ))}

                  {/* Rows */}
                  {options.map((feature, idx) => (
                    <React.Fragment key={idx}>
                      <div className="col-span-1 text-left px-4 py-3 border-b text-sm font-medium text-gray-700 bg-gray-50/50">
                        {feature.label}
                      </div>
                      {feature.value.map((val, col) => (
                        <div key={col} className="col-span-1 py-3 border-b flex justify-center items-center">
                          {val.value}
                        </div>
                      ))}
                    </React.Fragment>
                  ))}

                  {/* Bottom Buttons */}
                  <div className="col-span-1"></div>
                  {[1, 2, 3, 4].map((col) => (
                    <div key={col} className="col-span-1 py-6 bg-blue-50 rounded-b-xl">
                      {/* <button className="text-blue-600 border border-blue-600 px-4 py-1 rounded hover:bg-blue-600 hover:text-white transition text-sm font-semibold">
                        Select Plan
                      </button> */}
                    </div>
                  ))}

                </div>
              </div>
            </div>
          </section>

          {/* --- LOCATIONS & FOOTER --- */}
          <section className="bg-gray-100 py-12 text-center">
            <div className="max-w-7xl mx-auto px-4">
              <h3 className="text-xl text-gray-800 mb-6">Our Franchise <span className="text-xl font-bold">Locations</span></h3>
              <p className="text-xs text-gray-500 leading-loose">
                Delhi | Imphal | Aizawl
              </p>
            </div>
          </section>

        </div>

        <FooterStatic />
      </div>
    </>
  );
}
